import { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useQuery } from 'react-query'
import { fetchNaturaAllowedWarehouses } from '../../../services'

export const useNaturaWarehouseValidation = () => {
  const { warehouse_id } = useParams()
  const history = useHistory()
  const [showError, setShowError] = useState(false)

  const { data: allowedWarehouses } = useQuery(
    ['natura-allowed-warehouses'], 
    fetchNaturaAllowedWarehouses
  )

  const isWarehouseAllowed = allowedWarehouses?.some(
    warehouseId => warehouseId === parseInt(warehouse_id)
  )

  useEffect(() => {
    if (allowedWarehouses && !isWarehouseAllowed) {
      setShowError(true)
    }
  }, [allowedWarehouses, isWarehouseAllowed])

  return {
    warehouse_id,
    allowedWarehouses,
    isWarehouseAllowed,
    showError,
    navigateToWarehouses: () => history.push('/warehouses')
  }
} 